import { Col, Row } from 'antd'
import useLineItemCreate from 'app/components/Core/Checkout/hooks/useLineItemCreate'
import useMachineSearch from 'app/components/Core/Checkout/hooks/useMachineSearch'
import RecentMachinesList from 'app/components/Core/RecentMachine/List'
import KSearch from 'app/components/Modules/KSearch'
import { RecordType } from 'app/constants/GlobalTypes'
import * as React from 'react'
import testIds from 'test_ids.json'

const Machines: React.FC = () => {
  const { open: openLineItemCreate } = useLineItemCreate()

  const { open: openMachineSearch } = useMachineSearch()

  const onMachineSelect = (recentMachine: IRecentMachine) => {
    openLineItemCreate({
      categorySegmentId: recentMachine.categorySegment.id
    })
  }

  return (
    <Row gutter={[0, 12]}>
      <Col span={24} className={'px-2'}>
        <KSearch
          recordType={RecordType.category}
          onClick={() => openMachineSearch()}
          data-testid={testIds.checkout.machines.search.placeholder}
          showLabel
        />
      </Col>
      <Col span={24}>
        <RecentMachinesList onItemClick={onMachineSelect} />
      </Col>
    </Row>
  )
}

export default Machines
